/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_TitleInputs */

const vi_einvoice_title = /** @type {(inputs: Einvoice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn điện tử`)
};

/**

* @param {Einvoice_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_title = /** @type {((inputs?: Einvoice_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_title(inputs)
});